<template>
  <div class="el_container">
    <div class="el_title">診断結果</div>
    <radar-chart></radar-chart>
    <div class="ly_table">
      <table style="border-collapse: collapse;">
        <template v-for="(row, rowIndex) in rows" :key="rowIndex">
          <tr style="text-align: left;">
            <template v-for="(cell, cellIndex) in row.table_cells" :key="cellIndex">
              <td :class="getClass(rowIndex, cellIndex)">
                {{ cell }}
              </td>
            </template>
          </tr>
        </template>
      </table>
    </div>

    <material-button
      class="ly_button"
      text="次へ"
      font-size="28px"
      link="fin"
      padding="10px 52px 10px 52px"
    ></material-button>
  </div>
</template>
<script>
import MaterialButton from '../atoms/MaterialButton'
import RadarChart from '../atoms/RadarChart.vue'

export default {
  name: 'Result',
  components: { RadarChart, MaterialButton },
  data: () => ({
    evaluations: {
      kyoutyou: 1,
      omoi: 1,
      seiri: 1,
      syutai: 1,
    },
    rows: [],
  }),
  methods: {
    evaluateScore(score) {
      const standardDeviation = score * 10 + 50
      if (standardDeviation < 30) {
        return 1
      } else if (standardDeviation < 40) {
        return 2  
      } else if (standardDeviation < 60) {
        return 3
      } else if (standardDeviation < 70) {
        return 4
      } else {
        return 5
      }
    },
    evaluationToDescritpion(evaluation) {
      return {
        1: 'がかなり苦手',
        2: 'がちょっと苦手',
        3: 'は平均的',
        4: 'がかなり得意',
        5: 'がとても得意',
      }[evaluation]
    },
    evaluationToEmoticon(evaluation) {
      return {
        1: '😢',
        2: '🙁',
        3: '🙂',
        4: '😃',
        5: '😆',
      }[evaluation]
    },
    getClass(rowIndex, cellIndex) {
      // console.log(rowIndex, cellIndex)
      if (rowIndex > 0 && cellIndex == 1) {
        return 'td_border score'
      } else {
        return 'td_border'
      }
    },
  },
  mounted() {
    this.evaluations = {
      kyoutyou: this.evaluateScore(this.$store.state.result.kyoutyou),
      omoi: this.evaluateScore(this.$store.state.result.omoi),
      seiri: this.evaluateScore(this.$store.state.result.seiri),
      syutai: this.evaluateScore(this.$store.state.result.syutai),
    }
    this.rows = [
      {
        table_cells: ['スキル', 'スコア', '説明'],
      },
      {
        table_cells: [
          '自分の思いを表現する',
          `${this.evaluations.omoi}${this.evaluationToEmoticon(this.evaluations.omoi)}`,
          `自分の思っていることや伝えたいことを言葉やしぐさで表現するの${this.evaluationToDescritpion(this.evaluations.omoi)}`,
        ],
      },
      {
        table_cells: [
          '主体的に関与する',
          `${this.evaluations.syutai}${this.evaluationToEmoticon(this.evaluations.syutai)}`,
          `自分で主体的に相手に話しかけたりリーダーシップをとったりするの${this.evaluationToDescritpion(this.evaluations.syutai)}`,
        ],
      },
      {
        table_cells: [
          '協調して支援する',
          `${this.evaluations.kyoutyou}${this.evaluationToEmoticon(this.evaluations.kyoutyou)}`,
          `相手の気持ちに共感してクラスメートを支えるの${this.evaluationToDescritpion(this.evaluations.kyoutyou)}`,
        ],
      },
      {
        table_cells: [
          '自分の気持ちを整理する',
          `${this.evaluations.seiri}${this.evaluationToEmoticon(this.evaluations.seiri)}`,
          `その場の感情に左右されず気持ちを整理するの${this.evaluationToDescritpion(this.evaluations.seiri)}`,
        ],
      },
    ]
  },
 }
</script>

<style scoped>
.el_container {
  padding: 0px 10% 0px 10%;
}
.ly_chart {
  position: relative;
  width: 450px;
  height: 400px;
  top: 108px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 17px;
}
.ly_table {
  position: absolute;
  width: 600px;
  top: 158px;
  left: 610px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 17px;
  text-align: center;
}
.el_title {
  position: relative;
  height: 53px;
  text-align: left;
  top: 100px;
  font-size: 36px;
  color: #6b6b6b;
}

.el_result {
  position: absolute;
  text-align: left;
  left: 480px;
  top: -60px;
  font-size: 26px;
  line-height: 52px;
  color: #6b6b6b;
}

.el_result_text {
  position: absolute;
  left: 500px;
  text-align: left;
  width: 600px;
  top: -20px;
  line-height: 30px;
  color: #6b6b6b;
}

.ly_button {
  text-align: right;
  top: 50px;
  position: relative;
}

.td_border {
  /* padding: 10px 10px 10px 26px; */
  padding: 10px;
  border-bottom: 1px solid #bdbdbd;
}

.score {
  font-size: 30px;
  white-space: nowrap;
}

.td_border_last {
  /* padding: 10px 10px 10px 25px; */
  padding: 10px;
}
</style>
